import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { useServices } from "@core/servicesContext";
import { NextButton } from "@ui/components/buttons/nextButton";
import { TertiaryButton } from "@ui/components/buttons/tertiaryButton";
import { Row } from "@ui/components/layout";
import { toolbarStyle } from "@ui/components/toolbar";

export const OnboardingButtonWrapper = styled.div`
	@media (max-width: 900px) {
		${toolbarStyle};
	}
`;

export const OnboardingTitle = styled.div`
	${({ theme }) => theme.textStyles.title};
	max-width: 300px;
`;

export const OnboardingColored = styled.span`
	color: ${({ theme }) => theme.colors.primary};
`;

export const OnboardingDisconnect: React.FC<React.HTMLAttributes<HTMLButtonElement>> = ({ ...htmlProps }) => {
	const { currentProfileService } = useServices();

	return (
		<TertiaryButton onClick={() => currentProfileService.logout()} {...htmlProps}>
			{I18n.t("logout")}
		</TertiaryButton>
	);
};

interface OnboardingHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
	onBack: () => void;
}
export const OnboardingHeader: React.FC<OnboardingHeaderProps> = ({ children, onBack, ...htmlProps }) => {
	return (
		<Row gap={50} align="center" {...htmlProps}>
			<OnboardingButtonWrapper>
				<NextButton inverted onClick={onBack} />
			</OnboardingButtonWrapper>
			{children}
		</Row>
	);
};
